import { Injectable } from '@odinjs/odin';
import { ScheduleItem } from '../../../interfaces/schedules-suggestions';
import { NumberFormatUtils } from '../../../utils/number-format-utils';

export interface SchedulePrice {
  currencySymbol?: string;
  total: number;
}

@Injectable
export default class PseudonymSchedulePriceService {

  calculateSchedulePrice(suggestion: ScheduleItem, schedulePrice: SchedulePrice, verifyReturn = false as boolean): void {
    if (verifyReturn && suggestion.ieReturn) {
      return;
    }

    const matched = suggestion.price.trim().match(/(\S+) /);
    if (matched != null && !schedulePrice.currencySymbol) {
      schedulePrice.currencySymbol = matched[0];
    }
    schedulePrice.total = suggestion.priceNoFormatted + schedulePrice.total;
  }

  formatTotal(schedulePrice: SchedulePrice): string {
    return NumberFormatUtils.formatToCurrentLanguage(schedulePrice.total, schedulePrice.currencySymbol) || '0';
  }

}
